import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  requestForm!: FormGroup;
  resetForm!: FormGroup;
  message = '';
  errorMessage = '';

  constructor(private authService: AuthService) {}

  async ngOnInit(): Promise<void> {
    await this.authService.initializeService();
    this.requestForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });

    this.resetForm = new FormGroup({
      token: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.minLength(8)])
    });
  }

  requestReset(): void {
    this.message = '';
    this.errorMessage = '';
    if (this.requestForm.invalid) {
      this.requestForm.markAllAsTouched();
      return;
    }

    this.authService.forgotPassword(this.requestForm.getRawValue().email).subscribe({
      next: (response) => (this.message = response.message),
      error: (error) => (this.errorMessage = error?.error?.detail || 'Unable to start reset flow.')
    });
  }

  resetPassword(): void {
    this.message = '';
    this.errorMessage = '';
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
      return;
    }

    const { token, password } = this.resetForm.getRawValue();
    this.authService.resetPassword(token, password).subscribe({
      next: (response) => (this.message = response.message),
      error: (error) => (this.errorMessage = error?.error?.detail || 'Unable to reset password.')
    });
  }
}
